<template>
  <div class="container events">
    <div
      class="row mb-45"
    >
      <div class="col-8">
        <h1>Events</h1>
      </div>
      <div class="col-4 text-right">
        <router-link
          v-if="$store.getters.currentUser.canAddEvents"
          to="/events/create"
          tag="button"
          class="btn btn-primary profile-button btn-wide create-button"
        >
          <span>Create<span class="d-none d-md-inline"> Event</span></span>
        </router-link>
      </div>
    </div>

    <div class="row" v-if="$store.getters.currentUser.isAdmin">
      <div class="col-12">
        <div class="dashboard-card">
          <div class="upper college-typeahead">
            <input-type-ahead
              :list="colleges"
              :value="college"
              :searchchange="getColleges"
              :selected-value="selectedCollege"
              placeholder="Search for a College..."
              label="College"
              option-value="id"
              option-text="display_name"
            />
          </div>
        </div>
      </div>
    </div>


    <div class="row" v-if="!events">
      <Loader style="width: 100%;" />
    </div>

    <div class="row" v-else>
      <div class="col-12 d-lg-none">
        <button class="modal-filters btn-secondary large-filters-btn" type="button" @click="showFilters()">
          <font-awesome-icon
            :icon="['fas', 'sliders-v']"
            class="icon alt"
          />
          <span>Filters</span>
        </button>
      </div>
      <div class="col-12 col-lg-8">
        <div class="dashboard-card events-list" v-if="events.length === 0">
          No events were found.

          <div class="d-lg-none">
            <button class="btn modal-filters btn-primary mt-4" type="button" @click="showFilters()">
              Change Filters
            </button>
          </div>
        </div>

        <div class="dashboard-card events-list" v-else>

          <div class="upper">

            <p>Displaying {{events.length}} of {{count}} results</p>

            <div class="nav-buttons d-none d-lg-block">
              <button class="prev" type="button" @click="pageBack()" :disabled="page <= 0">
                <font-awesome-icon
                  :icon="['fas', 'caret-left']"
                  class="icon alt"
                />
              </button>
              <button class="next" type="button" @click="pageNext()" :disabled="page >= maxPage">
                <font-awesome-icon
                  :icon="['fas', 'caret-right']"
                  class="icon alt"
                />
              </button>
            </div>
          </div>
          <div class="event" v-for="event in events">
            <div class="row cursor-pointer" @click="viewEvent(event)">
              <div class="col-12 col-lg-8">
                <h3>{{event.topic}}</h3>
                <h5 v-if="event.counselor">{{event.counselor.name}}</h5>
                <p>{{event.start_time | date}}</p>
                <p>Location: {{event.in_person_location || 'Online'}}</p>
                <span class="spot-number d-lg-none">
                  <span v-if="event.joined">Joined!</span>
                  <span v-else-if="event.user_limit">{{event.num_spots_left}} Spot<span v-if="event.num_spots_left !== 1">s</span> Left!</span>
                  <span v-else>{{event.users_currently_attending}} Signed up</span>
                </span>
              </div>
              <div class="col-12 d-none d-lg-block col-lg-4 text-right">
                <ul class="pills">
                  <li v-if="event.joined">Joined!</li>
                  <li v-else-if="event.user_limit">{{event.num_spots_left}} Spot<span v-if="event.num_spots_left !== 1">s</span> Left</li>
                  <li v-else>{{event.users_currently_attending}} Signed up</li>
                </ul>
              </div>
            </div>
          </div>

          <div class="nav-buttons d-lg-none">
            <button class="prev" type="button" @click="pageBack()" :disabled="page <= 0">
              <font-awesome-icon
                :icon="['fas', 'caret-left']"
                class="icon alt"
              />
            </button>
            <button class="next" type="button" @click="pageNext()" :disabled="page >= maxPage">
              <font-awesome-icon
                :icon="['fas', 'caret-right']"
                class="icon alt"
              />
            </button>
          </div>
        </div>
      </div>
      <div class="d-none d-lg-block col-lg-4">
        <div class="dashboard-card filter-sidebar">
          <h2>Filter:</h2>
          <button class="btn back-btn" type="button" @click="resetFilters()">
            <span>Reset</span>
            <font-awesome-icon
              :icon="['fas', 'undo']"
              class="icon alt"
            />
          </button>
          <form-component>
            <form novalidate="novalidate" @submit.prevent>
              <label class="replacement-label">RELATED TOPICS</label>
              <div class="form-row hide-label">
                <div class="col-12">
                  <vue-tags-input
                    v-model="filters.specialty"
                    placeholder=""
                    :add-only-from-autocomplete="true"
                    :autocomplete-items="filteredSpecialties"
                    :autocomplete-min-length="0"
                    :tags="filters.specialty_ids"
                    label="Related Topic"
                    @tags-changed="specialtyChanged"
                  />
                </div>
              </div>
              <label v-if="$store.getters.currentUser.isStudent" class="replacement-label">PROVIDER GENDER</label>
              <div v-if="$store.getters.currentUser.isStudent" class="form-row hide-label">
                <div class="col-12">
                  <input-select
                    id="filters.gender"
                    v-model="filters.gender"
                    name="gender"
                    label="Gender"
                    type="select"
                    placeholder="Gender"
                    :options="counselorPreferenceGenderOptions"
                  />
                </div>
              </div>
              <!-- <label class="replacement-label">LANGUAGE</label>
              <div class="form-row hide-label">
                <div class="col-12">
                  <input-select
                    id="language"
                    v-model="filters.language"
                    name="language"
                    label="Language"
                    type="select"
                    placeholder="Language"
                    :options="languageOptions"
                  />
                </div>
              </div> -->
              
              <input-datepicker
                id="filters.start_time_after"
                v-model="filters.start_time_after"
                name="filters.start_time_after"
                label="Start Date"
                type="text"
                :disabled-dates="{ to: moment().toDate() }"
              />

              <input-datepicker
                id="filters.start_time_before"
                v-model="filters.start_time_before"
                name="filters.start_time_before"
                label="End Date"
                type="text"
                :disabled-dates="{ to: moment().toDate() }"
              />

              <!-- <input-text
                id="maxPrice"
                v-model="filters.maxPrice"
                name="maxPrice"
                label="Max Price"
                type="number"
              /> -->
            </form>
          </form-component>
        </div>
      </div>
    </div>

    <event-details-modal
      ref="eventDetailsModal"
      :updateEventsList="loadEvents"
      :viewAttendees="viewAttendees"
      :deleteEvent="deleteEvent" />

    <attendees-modal
      ref="attendeesModal"
      :event="selectedEvent" />

    <confirm-modal
      ref="confirmModal"
      title="Delete Event"
      confirm-body="Are you sure you want to delete this event?"
      :on-confirm="doDelete"
      cancel-text="No"
    />

    <b-modal
      ref="filtersModal"
      id="filters-modal"
      title="Filter"
    >
      
      <form-component>
        <form novalidate="novalidate" @submit.prevent>
          <label class="replacement-label">RELATED TOPICS</label>
          <div class="form-row hide-label">
            <div class="col-12">
              <vue-tags-input
                v-model="modalFilters.specialty"
                placeholder=""
                :add-only-from-autocomplete="true"
                :autocomplete-items="mobile_filteredSpecialties"
                :autocomplete-min-length="0"
                :tags="modalFilters.specialty_ids"
                label="Related Topic"
                @tags-changed="modalSpecialtyChanged"
              />
            </div>
          </div>
          <label v-if="$store.getters.currentUser.isStudent" class="replacement-label">PROVIDER GENDER</label>
          <div v-if="$store.getters.currentUser.isStudent" class="form-row hide-label">
            <div class="col-12">
              <input-select
                id="modalFilters.gender"
                v-model="modalFilters.gender"
                name="gender"
                label="Gender"
                type="select"
                placeholder="Gender"
                :options="counselorPreferenceGenderOptions"
              />
            </div>
          </div>
          <!-- <label class="replacement-label">LANGUAGE</label>
          <div class="form-row hide-label">
            <div class="col-12">
              <input-select
                id="language"
                v-model="modalFilters.language"
                name="language"
                label="Language"
                type="select"
                placeholder="Language"
                :options="languageOptions"
              />
            </div>
          </div> -->
          
          <input-datepicker
            id="modalFilters.start_time_after"
            v-model="modalFilters.start_time_after"
            name="modalFilters.start_time_after"
            label="Start Date"
            type="text"
            :disabled-dates="{ to: moment().toDate() }"
          />

          <input-datepicker
            id="modalFilters.start_time_before"
            v-model="modalFilters.start_time_before"
            name="modalFilters.start_time_before"
            label="End Date"
            type="text"
            :disabled-dates="{ to: moment().toDate() }"
          />

          <!-- <input-text
            id="maxPrice"
            v-model="modalFilters.maxPrice"
            name="maxPrice"
            label="Max Price"
            type="number"
          /> -->
        </form>
      </form-component>

      <template
        slot="modal-footer"
        slot-scope="{ ok, cancel }"
      >
        <button
          class="btn"
          type="button"
          @click="hideFilters()"
        >
          Cancel
        </button>
        <button
          class="btn btn--primary"
          type="button"
          @click="doModalFilters()"
        >
          Filter
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import FormComponent from '@/components/FormComponent.vue';
import InputText from '@/components/inputs/InputText.vue';
import InputTypeAhead from '@/components/inputs/InputTypeAhead.vue';
import InputSelect from '@/components/inputs/InputSelect.vue';
import InputDatepicker from '@/components/inputs/InputDatepicker.vue';
import VueTagsInput from '@johmun/vue-tags-input';
import EventDetailsModal from '@/components/modals/EventDetailsModal.vue';
import AttendeesModal from '@/components/modals/AttendeesModal.vue';
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import Loader from '@/components/Loader.vue';
import CounselorClient from '@/api/CounselorClient';
import StudentClient from '@/api/StudentClient';
import AdminClient from '@/api/AdminClient';
import UserClient from '@/api/UserClient';
import moment from 'moment';
import genderOptions from '@/helpers/mixins/gender-options';

export default {
  name: 'Events',
  components: {
    Loader,
    FormComponent,
    InputText,
    InputTypeAhead,
    InputSelect,
    VueTagsInput,
    EventDetailsModal,
    AttendeesModal,
    ConfirmModal,
    InputDatepicker,
  },
  mixins: [genderOptions],
  data() {
    return {
      counselorClient: new CounselorClient(this.$http),
      studentClient: new StudentClient(this.$http),
      adminClient: new AdminClient(this.$http),
      userClient: new UserClient(this.$http),
      selectedEvent: null,
      events: null,
      count: 0,
      page: 1,
      limit: 50,

      moment: moment,

      all_specialties: [],

      filters: {
        // search: '',
        gender: '',
        language: '',
        start_time_after: '',
        start_time_before: '',
        specialty: '',
        specialty_ids: [],
      },
      modalFilters: {
        // search: '',
        gender: '',
        language: '',
        start_time_after: '',
        start_time_before: '',
        specialty: '',
        specialty_ids: [],
      },

      // languageOptions: [],
      // typeahead
      colleges: [], // { id, name, state_code }
      _getCollegesTimeout: null,
      college: null,
    };
  },
  async mounted() {
    const all_specialties = await this.userClient.getSpecialtiesList('', 500);
    this.all_specialties = all_specialties.results || [];

    this.loadEvents();

    if (this.$store.getters.currentUser.isAdmin) {
      this.getColleges();
    }


    const { from } = this.$route.params;

    if (from && from === 'new-event') {
      this.$store.commit('setGlobalAlert', {
        msg: 'Event has been created!',
      });
    }
  },
  computed: {
    maxPage() {
      return Math.ceil(this.count / this.limit);
    },
    filteredSpecialties() {
      return this.all_specialties.filter(i => {
        return i.text.toLowerCase().indexOf(this.filters.specialty.toLowerCase()) !== -1;
      }).map(r => {
        return {
          id: r.id,
          text: r.text,
        };
      });
    },
    mobile_filteredSpecialties() {
      return this.all_specialties.filter(i => {
        return i.text.toLowerCase().indexOf(this.modalFilters.specialty.toLowerCase()) !== -1;
      }).map(r => {
        return {
          id: r.id,
          text: r.text,
        };
      });
    },
  },
  methods: {
    
    showFilters() {
      Object.keys(this.modalFilters).forEach(key => {
        this.modalFilters[key] = this.filters[key];
      });
      this.$refs.filtersModal.show();
    },

    doModalFilters() {
      Object.keys(this.modalFilters).forEach(key => {
        this.filters[key] = this.modalFilters[key];
      });
      this.hideFilters();
    },
    hideFilters() {
      this.$refs.filtersModal.hide();
    },

    // typeahead
    getColleges(query, done) {
      if (this.college && !query) {
        // we just selected one, do not empty the results
        return;
      }

      if (this._getCollegesTimeout) {
        clearTimeout(this._getCollegesTimeout);
        this._getCollegesTimeout = null;
      }

      this._getCollegesTimeout = setTimeout(() => {
        this.userClient.getCollegeList(query)
        // this.adminClient.getSchoolsList({
        //   search: query,
        // })
        .then((colleges) => {
          this.college = null;
          this.colleges = colleges.results || [];
        }).catch(() => {
          this.college = null;
          this.colleges = [];
        });
      }, 300);
    },
    selectedCollege(v) {
      this.college = v;

      if (this.college) {
        this.events = null;
        this.count = 0;
        this.loadEvents();
      } else {
        this.events = [];
        this.count = 0;
      }
    },

    viewAttendees() {
      this.counselorClient.getGroupSessionParticipants(this.selectedEvent.id).then(users => {
        this.$refs.attendeesModal.show(users);
      }).catch(ex => {

      });
    },

    loadEvents() {
      const offset = (this.page - 1) * this.limit;

      const filters = {};

      if (this.filters.search) {
        filters.search = this.filters.search;
      }

      if (this.filters.gender) {
        filters.gender = this.filters.gender;
      }

      if (this.filters.specialty_ids) {
        filters.related_topics = this.filters.specialty_ids.map(s => s.id).join(',');
      }

      if (this.filters.language) {
        filters.language = this.filters.language;
      }

      if (this.filters.start_time_after) {
        filters.start_time_after = moment(this.filters.start_time_after).startOf('day').toISOString();
      }

      if (this.filters.start_time_before) {
        filters.start_time_before = moment(this.filters.start_time_before).endOf('day').toISOString()
      }

      if (this.filters.maxPrice) {
        filters.maxPrice = this.filters.maxPrice;
      }

      if (this.$store.getters.currentUser.isAdmin) {
        filters.school = this.college;

        this.adminClient.getGroupEvents(filters, this.limit, offset).then(response => {
          this.events = response.results || [];
          this.count = response.count;
        });
      } else if (this.$store.getters.currentUser.isStudent) {
        this.studentClient.getGroupEvents(filters, this.limit, offset).then(response => {
          this.events = response.results || [];
          this.count = response.count;
        });
      } else {
        this.counselorClient.getGroupEvents(filters, this.limit, offset).then(response => {
          this.events = response.results || [];
          this.count = response.count;
        });
      }
    },
    onPageChanged(page) {
      if (page !== this.page) {
        this.page = page;

        if (this.page < 0) {
          this.page = 0;
        }

        if (this.page > this.maxPage) {
          this.page = this.maxPage;
        }

        this.loadEvents();
      }
    },
    pageBack() {
      this.onPageChanged(this.page - 1);
    },
    pageNext() {
      this.onPageChanged(this.page + 1);
    },


    resetFilters() {
      // this.filters.search = '';
      this.filters.specialty_ids = [];
      this.filters.specialty = '';
      this.filters.gender = '';
      this.filters.language = '';
      this.filters.start_time_after = '';
      this.filters.start_time_before = '';
      this.filters.maxPrice = '';

      this.loadEvents();
    },

    viewEvent(event) {
      this.selectedEvent = event;
      this.$refs.eventDetailsModal.show(event);
    },
    deleteEvent(event) {
      this.selectedEvent = event;
      this.$refs.confirmModal.show();
    },
    doDelete() {
      this.counselorClient.deleteEvent(this.selectedEvent.id).then(res => {
        this.loadEvents();
        this.$refs.confirmModal.hide();
        this.$refs.eventDetailsModal.hide();
        this.$store.commit('setGlobalAlert', {
          msg: 'Event Deleted',
        });
      }).catch(ex => {
        this.$store.commit('setGlobalAlert', {
          msg: 'Failed to delete event. Please try again!', error: true,
        });
        this.closing = false;
        this.$refs.confirmModal.hide();
      });
    },

    specialtyChanged(newTags) {
      this.filters.specialty_ids = newTags;
      this.loadEvents();
    },
    modalSpecialtyChanged(newTags) {
      this.modalFilters.specialty_ids = newTags;
      this.loadEvents();
    },
  },
  watch: {
    'filters.search'() {
      this.loadEvents();
    },
    'filters.gender'() {
      this.loadEvents();
    },
    'filters.language'() {
      this.loadEvents();
    },
    'filters.start_time_after'() {
      this.loadEvents();
    },
    'filters.start_time_before'() {
      this.loadEvents();
    },
    'filters.maxPrice'() {
      this.loadEvents();
    },
  },
};
</script>

<style lang="scss" scoped>
.events {
  .events-list {
    .upper {
      margin-bottom: 30px;
    }

    .nav-buttons {
      position: absolute;
      right: 42px;
      top: 28px;

      @media (max-width: $xs-max) {
        position: static;
        margin-top: 20px;
      }

      button {
        background: none;
        border: none;
        color: white;
        font-size: 30px;
        width: 35px;

        @media (max-width: $md-max) {
          width: 50px;
        }
      }
    }

    .event {
      @include border-radius($border-radius);

      border: solid 1px rgba(white, 0.5);
      padding: 30px;
      margin-bottom: 10px;

      p {
        color: rgba(white, 0.75);
        font-size: 18px;
        margin-bottom: 20px;
      }

      .spot-number {
        color: $green;
        margin-bottom: 30px;
        display: block;
        font-weight: bold;
      }
    }
  }

  .replacement-label {
    text-transform: uppercase;
    font-size: 10px;
    opacity: 0.75;
    letter-spacing: 0.1rem;
    margin-bottom: 5px;
    color: white;
  }

  .pills {
    margin-bottom: 0;
  }

  ::v-deep .dropdown-toggle {
    color: $green;
    background: none;
    width: 50px;
    border: none;
    padding-left: 0;
    padding-right: 0;
    text-align: center;
    font-size: 20px;
    position: relative;
    right: -20px;

    &::after {
      display: none !important;
    }
  }

  .create-button {
    display: inline-block;
    margin-top: 7px;
  }
}

.cursor-pointer {
  cursor: pointer !important;
}

.college-typeahead {
  ::v-deep .search {
    padding: 0 15px !important;
  }
}
</style>
